export enum FORM_ERROR_TYPE {
  FORM = 'form',
}
export enum FORM {
  PROFILE_EDIT_FORM = 'profile-edit-form',
  PROFILE_EDIT_PHOTO_UPLOAD_FORM = 'profile-edit-photo-upload-form',
}